<template>
  <div>
    <headers />

    <div id="login_wrap_denglu">
      <div class="login_wrap_denglu_top">申请合适的方案</div>
      <div class="yanzhengma_enter">更懂教育的一站式互动解决方案</div>
    </div>

    <div class="page flex-col">
        <div class="layer1 flex-col">
        <div class="wrap3 flex-row">
            <div class="box1 flex-col">
            <div class="main1 flex-col">
                <span class="word5">试用版</span>
                <span class="txt2">免费试用</span>
                <button class="main2 flex-col" @click="goToApplyPage(1)">
                    <span class="word10">免费体验</span>
                </button>
                <span class="word6">互动教室</span>
                <div class="box3 flex-col"></div>
                <span class="word7">多种互动工具</span>
                <div class="box4 flex-col"></div>
                <span class="info4">后台管理系统</span>
                <div class="box5 flex-col"></div>
                <span class="word8">共享屏幕及互动批注</span>
                <div class="box6 flex-col"></div>
                <span class="txt4">7天免费使用时长</span>
            </div>
            </div>
            <div class="box7 flex-col">
            <div class="bd2 flex-col">
                <span class="info5">专业学校版</span>
                <span class="word9">适用于有开发团队的学校</span>
                <button class="main2 flex-col"  @click="goToApplyPage(3)">
                <span class="word10">立即申请</span>
                </button>
                <span class="txt5">互动教室</span>
                <div class="main3 flex-col"></div>
                <span class="word11">多种互动工具</span>
                <div class="main4 flex-col"></div>
                <span class="word12">后台管理系统</span>
                <div class="main5 flex-col"></div>
                <span class="word13">共享屏幕及互动批注</span>
                <div class="main6 flex-col"></div>
                <span class="word14">1080p高清画质</span>
                <div class="main7 flex-col"></div>
                <span class="word15">直播、录播回放功能</span>
                <div class="main8 flex-col"></div>
                <span class="txt6">500G免费云存储空间</span>
                <div class="main9 flex-col"></div>
                <span class="word16">自定义云录制储存时长</span>
                <div class="main10 flex-col"></div>
                <span class="word17">VIP售后服务群培训答疑</span>
                <div class="main11 flex-col"></div>
                <span class="word18">API数据对接</span>
                <div class="main12 flex-col"></div>
                <span class="info6">更优惠的价格</span>
            </div>
            </div>
        </div>
        </div>
        <div class="layer3 flex-col">
        <div class="outer1 flex-col">
            <span class="info7">学校版</span>
            <span class="info8">适用于大中小型学校</span>
            <button class="outer2 flex-col"  @click="goToApplyPage(2)">
            <span class="word19">立即申请</span>
            </button>
            <span class="word20">互动教室</span>
            <div class="outer3 flex-col"></div>
            <span class="word21">多种互动工具</span>
            <div class="outer4 flex-col"></div>
            <span class="word22">后台管理系统</span>
            <div class="outer5 flex-col"></div>
            <span class="word23">共享屏幕及互动批注</span>
            <div class="outer6 flex-col"></div>
            <span class="info9">可选1080p高清画质</span>
            <div class="outer7 flex-col"></div>
            <span class="word24">可选直播、录播回放功能</span>
            <div class="outer8 flex-col"></div>
            <span class="word25">100GB免费云存储空间</span>
            <div class="outer9 flex-col"></div>
            <span class="word26">自定义云录制储存时长</span>
            <div class="outer10 flex-col"></div>
            <span class="word27">VIP售后服务群培训答疑</span>
        </div>
        </div>
    </div>
    
    <footers />
  </div>
</template>
<script>

    import headers from "./header.vue";
    import footers from "./footers.vue";
    import { try_get_token } from "../apis/token.js";
    import Net_Work from "../apis/network.js";

    import axios from "axios";

    axios.defaults.baseURL = Net_Work.publicApi;
    axios.defaults.headers.post["Content-Type"] = Net_Work.publicPostset;

    export default {
        components: {
            headers,
            footers
        },
        data() {
            return {
                constants: {}
            };
        },
        methods: {
          goToApplyPage(version){

              // 判断是否登录，获取token
              var accessToken = try_get_token();
              var _this = this;

              // 如果都不存在，跳转登录页面
              if(!accessToken){
                  this.$message.error({
                    message: "请先登录",
                    duration: 2000,
                    onClose() {
                        _this.$router.push("/school-join");
                    }
                });
              } else {

                    axios.defaults.headers.common["Authorization"] = accessToken;

                    // 如果已经有了学校信息，则直接跳转申请页面，否则，跳转信息页面
                    axios.get("/s/api/school/getApplySchool").then(function(response) {
                        if (response.data.code === 0) {
                            if (response.data.data) {
                                 _this.$router.push({
                                    path: "/solution-apply",
                                    query: {
                                        version: version
                                    }
                                });
                            }
                            else {
                                 _this.$router.push({
                                    path: "/school-information",
                                    query: {
                                        version: version
                                    }
                                });
                            }
                        }
                    });

                   
              }

          }
        }
    };

</script>
<style scoped lang="css" src="./assets/public.css" ></style>
<style scoped lang="css" src="./assets/common.css" ></style>
<style scoped lang="css" src="./assets/solution.css" /></style>


// WEBPACK FOOTER //
// src/components/solution.vue